// Shared NxHUB cache-key builders. These endpoints are cookie-auth/org-scoped;
// organizationId partitions the client cache only and is not sent on the wire.

export const voiceSubscriptionsQueryKey = (
    organizationId: string | undefined,
    subscriberDeviceSerial: string,
) => ['nxhub-voice-subscriptions', organizationId ?? '', subscriberDeviceSerial];

export const allNxHubDevicesQueryKey = (organizationId: string | undefined) =>
    ['nxhub-all-devices', organizationId ?? ''];

export const alertHistoryQueryKey = (organizationId: string | undefined) =>
    ['nxhub-alert-history', organizationId ?? ''];

export const voiceMessageHistoryQueryKey = (organizationId: string | undefined) =>
    ['nxhub-voice-message-history', organizationId ?? ''];
